export default {
  namespaced: true,
  state: {
    dialogBoxVisibleStatus: false
  },
  getters: {
    getStateOfDialogBox: function(state) {
      return state.dialogBoxVisibleStatus;
    }
  },
  mutations: {
    SET_DIALOG_BOX_VISIBLE_STATUS(state, isDialogBoxVisibleStatus) {
      state.dialogBoxVisibleStatus = isDialogBoxVisibleStatus;
    }
  },
  actions: {
    changeDialogBoxVisibleStatus({ commit }, isDialogBoxVisibleStatus) {
      commit("SET_DIALOG_BOX_VISIBLE_STATUS", isDialogBoxVisibleStatus);
    }
  }
};
